var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientSatisfactionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 61,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ClientSatisfaction_icon_svg__a",
    d: "M0 0h25.58v4.845H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.542 52.866C6.156 48.435 1.22 41.024 0 32.534l2.01-.288c1.134 7.88 5.718 14.761 12.578 18.877l-1.046 1.743zM43.044 52.704l-1.065-1.73c6.719-4.133 11.213-10.958 12.33-18.728l2.012.289c-1.203 8.369-6.042 15.72-13.277 20.17",
    fill: "#BCC0C4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ClientSatisfaction_icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ClientSatisfaction_icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.915 4.845L0 3.031A28.16 28.16 0 0112.791-.001c4.498 0 8.801 1.02 12.79 3.03l-.915 1.816A26.141 26.141 0 0012.79 2.032c-4.177 0-8.174.947-11.876 2.813",
    fill: "#BCC0C4",
    mask: "url(#ClientSatisfaction_icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.508 10.21a5.08 5.08 0 00-5.08 5.08v1.016h10.16V15.29a5.08 5.08 0 00-5.08-5.08",
    fill: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.476 16.306h7.113V15.29a5.081 5.081 0 00-5.081-5.08h-5.08",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.846 15.29a5.081 5.081 0 015.081-5.08h36.581a5.081 5.081 0 00-5.08 5.08v39.63A5.081 5.081 0 0141.346 60h-31.5V15.29z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.927 10.21a5.08 5.08 0 00-5.08 5.08V60h31.5a5.08 5.08 0 005.08-5.08V15.29a5.08 5.08 0 015.081-5.08H14.927z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 54.92A5.081 5.081 0 008.83 60h32.517a5.081 5.081 0 01-5.081-5.08H3.749z",
    fill: "#F4A27F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 54.92A5.081 5.081 0 008.83 60h32.517a5.081 5.081 0 01-5.081-5.08H3.749z",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.959 35.613h22.355M16.959 40.693h22.355M16.959 45.774h11.178M32.201 20.371h7.113M32.201 25.451h7.113M32.201 30.532h7.113M28.137 30.534v-2.032c0-1.325-3.076-3.048-5.589-3.048-2.513 0-5.589 1.723-5.589 3.048v2.032M22.548 17.322c-1.84 0-3.556 1.311-3.556 2.928v2.274c0 1.616 1.717 2.927 3.556 2.927 1.84 0 3.557-1.31 3.557-2.927V20.25c0-1.617-1.718-2.928-3.557-2.928z"
  }))));
}
export default SvgClientSatisfactionIcon;